import { render } from "./LicenseAlert.vue?vue&type=template&id=14b8dc52&scoped=true"
import script from "./LicenseAlert.vue?vue&type=script&lang=js"
export * from "./LicenseAlert.vue?vue&type=script&lang=js"

import "./LicenseAlert.vue?vue&type=style&index=0&id=14b8dc52&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b8dc52"]])

export default __exports__